class CartConsents extends HTMLElement {
	static checkedConsents = new Set();

	constructor() {
		super();

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBlockedClick = this.onBlockedClick.bind(this);
	}

	connectedCallback() {
		this.inputs = Array.from(this.querySelectorAll("[data-cart-consent]"));
		this.form = this.inputs[0]?.form;

		this.inputs.forEach((input) => {
			input.checked = CartConsents.checkedConsents.has(input.dataset.cartConsent);
		});

		this.addEventListener("change", this.onChange);
		this.form?.addEventListener("submit", this.onSubmit, true);
		document.addEventListener("click", this.onBlockedClick);

		this.update();
	}

	disconnectedCallback() {
		this.removeEventListener("change", this.onChange);
		this.form?.removeEventListener("submit", this.onSubmit, true);
		document.removeEventListener("click", this.onBlockedClick);
	}

	get accepted() {
		return this.inputs.every((input) => input.checked);
	}

	onChange(event) {
		const input = event.target.closest("[data-cart-consent]");
		if (!input) return;

		if (input.checked) CartConsents.checkedConsents.add(input.dataset.cartConsent);
		else CartConsents.checkedConsents.delete(input.dataset.cartConsent);

		this.update();
	}

	onSubmit(event) {
		if (event.submitter?.name !== "checkout" || this.accepted) return;

		event.preventDefault();
		this.showError();
	}

	onBlockedClick(event) {
		if (event.target.closest(".cart-consents--blocked")) this.showError();
	}

	update() {
		document
			.querySelectorAll(".cart__dynamic-checkout-buttons")
			.forEach((el) => el.classList.toggle("cart-consents--blocked", !this.accepted));
	}

	showError() {
		window.alert(this.dataset.error);
	}
}

if (!customElements.get("cart-consents")) {
	customElements.define("cart-consents", CartConsents);
}
